import { RootState } from '../store';

export const selectIsReconsentModalOpen = (state: RootState): boolean =>
  state.reconsent.isModalOpen;

export const selectReconsentActivationSource = (state: RootState): string =>
  state.reconsent.activationSource;
